var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screen-back"},[_c('i',{staticClass:"el-icon-close"}),_c('span',{staticClass:"text"},[_vm._v("退出")])])}]

export { render, staticRenderFns }